/**
 * Schedule datasource
 */
export function applyCategoryColor(args, currentView) {
    let categoryColor = args.data.CategoryColor;
    if (!args.element || !categoryColor) {
        return;
    }
    if (currentView === 'Agenda') {
        args.element.firstChild.style.borderLeftColor = categoryColor;
    }
    else {
        args.element.style.backgroundColor = categoryColor;
    }
}


export let eventsData = [


    // {
    //     tenantId: 1,
    //     userId: 1,
    //     requestId: 9,
    //     tenantName: "IR_Demo test",
    //     buildingName: "VinayMainSC",
    //     zoneName: "Test zone",
    //     StartTime: "2018-12-10T13:37:00+00:00",
    //     EndTime: "2018-12-10T15:37:00+00:00",
    //     createdBy: "Tracer ES User Administrator",
    // },

    {
        tenantId: 1,
        userId: 1,
        requestId: 9,
        tenantName: "IR_Demo teadsfst",
        buildingName: "VinayMainSC",
        place: "Test zone",
        // StartTime: new Date(2018, 1, 11, 10, 0),
        // EndTime: new Date(2018, 1, 11, 11, 30),
        startDateTime: "2018-12-10T16:43:00+00:00",
        stopDateTime: "2018-12-10T18:43:00+00:00",
        createdBy: "Tracer ES User Administrator",
    },

    {
        tenantId: 1,
        userId: 1,
        requestId: 19,
        tenantName: "IR_Demo peestest",
        buildingName: "VinayMainSC",
        City: "Test zone",
        // startDateTime: new Date(2018, 1, 11, 10, 0),
        // stopDateTime: new Date(2018, 1, 11, 11, 30),
        startDateTime: "2018-12-10T16:43:00+00:00",
        stopDateTime: "2018-12-10T18:43:00+00:00",
        createdBy: "Tracer ES User Administrator",
    },

    {
        tenantId: 1,
        userId: 1,
        requestId: 29,
        tenantName: "IR_Demo test",
        buildingName: "VinayMainSC",
        City: "Test zone",
        startDateTime: "2018-12-10T16:43:00+00:00",
        stopDateTime: "2018-12-10T18:43:00+00:00",
        createdBy: "Tracer ES User Administrator",
    },

    // {
    //     Id: 1,
    //     Subject: 'Server Maintenance',
    //     StartTime: new Date(2018, 1, 11, 10, 0),
    //     EndTime: new Date(2018, 1, 11, 11, 30),
    //     EventType: 'maintenance',
    //     City: 'Seattle',
    //     CategoryColor: '#1aaa55'
    // }, {
    //     Id: 2,
    //     Subject: 'Art & Painting Gallery',
    //     StartTime: new Date(2018, 1, 12, 12, 0),
    //     EndTime: new Date(2018, 1, 12, 14, 0),
    //     EventType: 'public-event',
    //     City: 'Costa Rica',
    //     CategoryColor: '#357cd2'
    // }, {
    //     Id: 3,
    //     Subject: 'Dany Birthday Celebration',
    //     StartTime: new Date(2018, 1, 13, 10, 0),
    //     EndTime: new Date(2018, 1, 13, 11, 30),
    //     EventType: 'family-event',
    //     City: 'Kirkland',
    //     CategoryColor: '#7fa900'
    // }, {
    //     Id: 4,
    //     Subject: 'John Wedding Anniversary',
    //     StartTime: new Date(2018, 1, 14, 9, 0),
    //     EndTime: new Date(2018, 1, 14, 10, 0),
    //     EventType: 'family-event',
    //     City: 'Redmond',
    //     CategoryColor: '#ea7a57'
    // }, {
    //     Id: 5,
    //     Subject: 'ISA Annual Conference',
    //     StartTime: new Date(2018, 1, 15, 10, 0),
    //     EndTime: new Date(2018, 1, 15, 11, 30),
    //     EventType: 'commercial-event',
    //     City: 'USA',
    //     CategoryColor: '#00bdae'
    // }, {
    //     Id: 6,
    //     Subject: 'Equipment Maintenance',
    //     StartTime: new Date(2018, 1, 16, 12, 0),
    //     EndTime: new Date(2018, 1, 16, 14, 0),
    //     EventType: 'maintenance',
    //     City: 'Seattle',
    //     CategoryColor: '#f57f17'
    // }, {
    //     Id: 7,
    //     Subject: 'Aircraft Maintenance',
    //     StartTime: new Date(2018, 1, 17, 10, 0),
    //     EndTime: new Date(2018, 1, 17, 11, 30),
    //     EventType: 'maintenance',
    //     City: 'Seattle',
    //     CategoryColor: '#1aaa55'
    // }, {
    //     Id: 8,
    //     Subject: 'Facilities Maintenance',
    //     StartTime: new Date(2018, 1, 19, 9, 30),
    //     EndTime: new Date(2018, 1, 19, 11, 0),
    //     EventType: 'maintenance',
    //     City: 'Seattle',
    //     CategoryColor: '#357cd2'
    // }, {
    //     Id: 9,
    //     Subject: 'Britto Birthday Celebration',
    //     StartTime: new Date(2018, 1, 21, 11, 0),
    //     EndTime: new Date(2018, 1, 21, 13, 0),
    //     EventType: 'family-event',
    //     City: 'Greenland',
    //     CategoryColor: '#7fa900'
    // }, {
    //     Id: 10,
    //     Subject: 'Justin Wedding Anniversary',
    //     StartTime: new Date(2018, 1, 22, 9, 30),
    //     EndTime: new Date(2018, 1, 22, 11, 0),
    //     EventType: 'family-event',
    //     City: 'Finland',
    //     CategoryColor: '#ea7a57'
    // }, {
    //     Id: 11,
    //     Subject: 'AIEA Annual Meet',
    //     StartTime: new Date(2018, 1, 9, 10, 0),
    //     EndTime: new Date(2018, 1, 9, 11, 30),
    //     EventType: 'commercial-event',
    //     City: 'USA',
    //     CategoryColor: '#00bdae'
    // }, {
    //     Id: 12,
    //     Subject: 'AAN Conference',
    //     StartTime: new Date(2018, 1, 7, 10, 30),
    //     EndTime: new Date(2018, 1, 7, 12, 30),
    //     EventType: 'commercial-event',
    //     City: 'USA',
    //     CategoryColor: '#f57f17'
    // }, {
    //     Id: 13,
    //     Subject: 'Photography Gallery',
    //     StartTime: new Date(2018, 1, 5, 10, 0),
    //     EndTime: new Date(2018, 1, 5, 11, 30),
    //     EventType: 'public-event',
    //     City: 'Chennai',
    //     CategoryColor: '#1aaa55'
    // }, {
    //     Id: 14,
    //     Subject: 'Beach Clean-up',
    //     StartTime: new Date(2018, 1, 14, 12, 0),
    //     EndTime: new Date(2018, 1, 14, 2, 0),
    //     EventType: 'public-event',
    //     City: 'Mumbai',
    //     CategoryColor: '#357cd2'
    // }, {
    //     Id: 15,
    //     Subject: 'Turtle Walk',
    //     StartTime: new Date(2018, 1, 19, 13, 0),
    //     EndTime: new Date(2018, 1, 19, 14, 30),
    //     EventType: 'public-event',
    //     City: 'Costa Rica',
    //     CategoryColor: '#7fa900'
    // }, {
    //     Id: 16,
    //     Subject: 'Silent Walk for Cancer day',
    //     StartTime: new Date(2018, 1, 22, 13, 0),
    //     EndTime: new Date(2018, 1, 22, 14, 30),
    //     EventType: 'public-event',
    //     City: 'Chennai',
    //     CategoryColor: '#ea7a57'
    // }, {
    //     Id: 17,
    //     Subject: 'Beach Clean-up',
    //     StartTime: new Date(2018, 1, 13, 14, 0),
    //     EndTime: new Date(2018, 1, 13, 16, 0),
    //     EventType: 'public-event',
    //     City: 'Mumbai',
    //     CategoryColor: '#357cd2'
    // }, {
    //     Id: 18,
    //     Subject: 'Photography Gallery',
    //     StartTime: new Date(2018, 1, 15, 14, 0),
    //     EndTime: new Date(2018, 1, 15, 16, 0),
    //     EventType: 'public-event',
    //     City: 'Chennai',
    //     CategoryColor: '#1aaa55'
    // }

];

